import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://muonryrwkrbmdaqqaobj.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im11b25yeXJ3a3JibWRhcXFhb2JqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzUzNjI2NDksImV4cCI6MjA5MDkzODY0OX0.TTirEUiT6_af4SAsZMTfk04FqeG_NLu8p5iP15Sef0Y'

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})
